angular.module('taric.documentation', [])
    .component('documentationButton', require('./components/documentation-button'))
    .factory('documentationService', require('./services/documentation-service'))
    ;


